import { Sentry } from './lib/sentry.js'
import { initWebVitals } from './lib/web-vitals.js'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './lib/queryClient.js'
import { SocketProvider } from './lib/socket-context.jsx'
import { LanguageProvider } from './i18n/index.jsx'
import { ErrorBoundary } from './components/ErrorBoundary.jsx'
import { installGlobalErrorHandlers } from './lib/global-error-handlers.js'
import App from './App.jsx'
import './index.css'

// Catch promise rejections and top-level errors that escape React's
// ErrorBoundary (e.g. fire-and-forget fetches, setTimeout callbacks,
// module-load promises). Forwards to Sentry when configured and always
// logs to the console for dev visibility.
installGlobalErrorHandlers({ Sentry })
initWebVitals()

// Apply saved theme before first render to prevent flash
const savedTheme = localStorage.getItem('stagewise-theme') || 'dark'
document.documentElement.setAttribute('data-theme', savedTheme)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary
      onReset={() => window.location.reload()}
    >
      <QueryClientProvider client={queryClient}>
        <SocketProvider>
          <LanguageProvider>
            <App />
          </LanguageProvider>
        </SocketProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)
